<template>
  <div id="dashboardMcmv" class="column resumo-subsidio-mcmv">
    <div v-show="deveExibirDados"
         class="cabecalho-dashboard-mcmv container container_com-fundo container_com-margem">
      <loading :ativo="loading" />
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />

      <div class="u-margem-inferior-pequena">
        <div class="investimento-inicial">
          <div class="icone">
            <i class="fal fa-sack-dollar"></i>
          </div>
          <div class="valor">
            <p>{{ valorTotalDoProjeto }}</p>
            <span>
              Investimento de programa
              <strong>{{ this.dadosDoFiltro.projetoNome }}</strong>
            </span>
          </div>
        </div>
        <button type="button"
                onclick="window.print()"
                class="no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_sem-preenchimento botao_grande">
          <i class="fal fa-print" aria-hidden="true"></i>
          Imprimir
        </button>
      </div>

      <div v-show="deveExibirDados">
        <div class="card-container">
          <div v-for="status of dadosPorStatus" :key="status.nome">
            <DashCard :headerColor="status.classeCss"
                      :status="status.nome"
                      :quantidadeDeSolicitacoes="status.quantidade"
                      :valor="status.valorFormatado"
                      :porcentagem="status.valorPercentual" />
          </div>
        </div>

        <div class="progress-mcmv progress-saldo-total-mcmv">
          <div v-for="status of dadosPorStatus"
               :class="['progress-bar-mcmv', status.classeCss]"
               :style="{ width: `${status.valorPercentual}%` }"
               role="progressbar"
               aria-valuenow="60"
               aria-valuemin="0"
               aria-valuemax="100"></div>
        </div>
        <div class="grade__linha grade__linha_alinhar-vertical-a-base">
          <div class="grade__coluna grade__coluna_6">
            <div class="grafico-familias-mcmv u-margem-superior-media">
              <div class="icone-familia">
                <i class="fal fa-users" aria-hidden="true"></i>
                <h2>Famílias já atendidas por faixa</h2>
              </div>
              <div class="area-graficos-mcmv">
                <div class="grafico-mcmv">
                  <canvas id="graficoDeResumo"
                          width="300px"
                          height="300px"></canvas>
                </div>
                <div class="legenda-mcmv">
                  <ul>
                    <li v-for="legenda of dadosDaLegendaParaResumo.filter(
                        (legenda)=>
                      legenda.deveMostrarNaLista
                      )"
                      >
                      <span class="figura"
                            :style="{ background: `${legenda.cor}` }"></span>
                      <span class="titulo">
                        {{ legenda.quantidade }}
                        {{ legenda.quantidade === 1 ? "família" : "famílias" }}
                        <p>{{ legenda.nomeDaFaixa }}</p>
                      </span>
                    </li>
                  </ul>
                  <div class="total-atendido-mcmv">
                    Total de
                    <strong>
                      {{ totalDeFamiliasAtendidas }}
                      {{
                        totalDeFamiliasAtendidas === 1 ? "família" : "famílias"
                      }}
                    </strong>
                    já atendidas
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grade__coluna grade__coluna_6">
            <div class="grafico-familias-mcmv u-margem-superior-media">
              <div class="icone-familia">
                <i class="fa-light fa-chart-pie-simple-circle-dollar"
                   aria-hidden="true"></i>
                <h2>Recursos ainda disponíveis por faixa</h2>
              </div>
              <div class="area-graficos-mcmv">
                <div class="grafico-mcmv">
                  <canvas id="graficoDeRecursosDisponiveis"
                          width="300px"
                          height="300px"></canvas>
                </div>
                <div class="legenda-mcmv">
                  <ul>
                    <li v-for="legenda of dadosDaLegendaParaRecursos">
                      <span class="figura"
                            :style="{ background: `${legenda.cor}` }"></span>
                      <span class="titulo">
                        {{ legenda.valor }}
                        <p>{{ legenda.nomeDaFaixa }}</p>
                      </span>
                    </li>
                  </ul>
                  <div class="total-atendido-mcmv">
                    Total de
                    <strong>{{ totalDeRecursosDisponiveis }}</strong> restantes
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="print">
        <div class="printar-data">
          Impresso em {{ new Date().toLocaleDateString("pt-BR") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import Chart from "chart-js";
  import Loading from "../shared/Loading.vue";
  import Alerta from "../shared/Alerta";
  import DashCard from "../shared/DashCard.vue";

  export default {
    props: {
      dadosDoFiltro: {
        type: Object,
        required: true,
        default: () => ({
          idProjeto: null,
          idCidade: null,
          projetoNome: "",
          projetoEhMcmvCidades: false,
        }),
      },
    },
    components: { Loading, Alerta, DashCard },
    name: "dashboardMcmv",
    data() {
      return {
        tipoDeAlerta: null,
        mensagemDeAlerta: null,
        cidades: null,
        cidade: this.dadosDoFiltro.idCidade || null,
        loading: false,
        valorTotalDoProjeto: null,
        graficoDeResumo: null,
        graficoDeRecursosDisponiveis: null,
        dadosPorStatus: [],
        dadosDaLegendaParaResumo: [],
        dadosDaLegendaParaRecursos: [],
        dadosParaGrafico: [],
        totalDeFamiliasAtendidas: null,
        totalDeRecursosDisponiveis: null,
      };
    },
    computed: {
      deveExibirDados() {
        const { idProjeto, projetoEhMcmvCidades } = this.dadosDoFiltro;
        const projetoNaoEhVazio = idProjeto !== null;
        return (
          this.dadosPorStatus.length > 0 &&
          projetoEhMcmvCidades &&
          projetoNaoEhVazio
        );
      },
    },
    watch: {
      dadosDoFiltro(dadosDoFiltro) {
        this.dadosDoFiltro = dadosDoFiltro;
        this.verificarEObterDados();
      },
    },
    methods: {
      verificarEObterDados() {
        if (
          this.dadosDoFiltro.projetoEhMcmvCidades &&
          this.dadosDoFiltro.idProjeto
        ) {
          if (this.dadosDoFiltro.idProjeto) {
            this.obterDados();
          } else {
            this.exibirAlerta("Informe o projeto");
            return;
          }
        }
      },
      obterDados() {
        let url = "/Dashboard/ObterDadosMcmv";
        const params = { projetoId: this.dadosDoFiltro.idProjeto };
        if (this.dadosDoFiltro.idCidade) {
          params.cidadeId = this.dadosDoFiltro.idCidade;
        }
        this.loading = true;
        this.$api.post(url, params).then((response) => {
          const dados = response.data;
          this.valorTotalDoProjeto = this.$moeda.formatar(
            dados.ValorTotalDoProjeto
          );
          this.dadosPorStatus = this.gerarDados(dados.ResumosPorStatus);
          this.totalDeFamiliasAtendidas = dados.TotalDeFamilias;
          this.totalDeRecursosDisponiveis = this.$moeda.formatar(
            dados.TotalDeRecursosDisponiveis
          );
          const dadosParaGraficoDeResumo =
            this.gerarDadosParaGraficoDeResumo(dados);
          const dadosParaGraficoDeRecursosDisponiveis =
            this.gerarDadosParaGraficoDeRecursosDisponiveis(dados);
          this.$emit("atualizarValorTotal", this.valorTotalDoProjeto);
          this.loading = false;
          this.$nextTick(() => {
            this.gerenciarGraficoDeResumo(dadosParaGraficoDeResumo);
            this.gerenciarGraficoDeRecursosDisponiveis(
              dadosParaGraficoDeRecursosDisponiveis
            );
          });
        });
      },
      gerarDadosParaGraficoDeResumo(dadosDoGrafico) {
        this.dadosDaLegendaParaResumo = [];
        const dados = dadosDoGrafico.ResumosPorFaixa;

        const valores = [];
        const cores = [];
        const labels = [];

        dados.forEach((dado) => {
          let cor = this.obterCorPorValor(dado.NomeDaFaixa);

          valores.push(dado.Percentual);
          cores.push(cor);
          labels.push(dado.NomeDaFaixa);

          this.dadosDaLegendaParaResumo.push({
            cor: cor,
            quantidade: dado.Quantidade,
            deveMostrarNaLista: dado.DescricaoDaFaixa !== "Recursos disponíveis",
            nomeDaFaixa: dado.DescricaoDaFaixa,
          });
        });

        let dataset = {
          label: "Subsídio por família",
          data: valores,
          backgroundColor: cores,
        };

        return {
          dataset: dataset,
          chartId: "graficoDeResumo",
          labels: labels,
        };
      },
      gerarDadosParaGraficoDeRecursosDisponiveis(dadosDoGrafico) {
        this.dadosDaLegendaParaRecursos = [];
        const dadosParaRecursos = dadosDoGrafico.RecursosDisponiveisPorFaixa;

        const valores = [];
        const cores = [];
        const labels = [];

        dadosParaRecursos.forEach((dado) => {
          let cor = this.obterCorPorValor(dado.NomeDaFaixa);

          valores.push(dado.PercentualDeRecursos);
          cores.push(cor);
          labels.push(dado.NomeDaFaixa);

          this.dadosDaLegendaParaRecursos.push({
            cor: cor,
            valor: this.$moeda.formatar(dado.ValorDisponivel),
            nomeDaFaixa: dado.DescricaoDaFaixaPorImovelDisponivel,
          });
        });

        let dataset = {
          data: valores,
          backgroundColor: cores,
        };

        return {
          dataset: dataset,
          chartId: "graficoDeRecursosDisponiveis",
          labels: labels,
        };
      },
      obterCorPorValor(descricao) {
        const cores = {
          "Faixa 1": "rgba(148, 32, 0, 1)",
          "Faixa 2": "rgba(199, 63, 25, 1)",
          "Faixa 3": "rgba(255, 206, 193, 1)",
          "Faixa 1 terreno público doado": "rgba(148, 32, 0, 0.4)",
          "Faixa 2 terreno público doado": "rgba(199, 63, 25, 0.4)",
          "Faixa 3 terreno público doado": "rgba(255, 206, 193, 0.4)",
        };
        let corPorvalor = cores[descricao];

        if (!corPorvalor) {
          const x = Math.floor(Math.random() * 256);
          const y = Math.floor(Math.random() * 256);
          const z = Math.floor(Math.random() * 256);
          corPorvalor = `rgba(${x}, ${y}, ${z}, 1)`;
        }
        return corPorvalor;
      },
      gerarDados(dadosPorStatus) {
        const dados = [];

        dadosPorStatus.forEach((status) => {
          const descricao = status.Descricao;
          const informacoesPorStatus = { nome: descricao };

          informacoesPorStatus.classeCss =
            descricao
              .replace("ã", "a")
              .replace("í", "i")
              .split(" ")
              .join("-")
              .toLowerCase() + "-mcmv";
          informacoesPorStatus.valor = status.Valor;
          informacoesPorStatus.valorFormatado = this.$moeda.formatar(
            status.Valor
          );
          informacoesPorStatus.valorPercentual = status.ValorPercentual;
          informacoesPorStatus.quantidade = status.Quantidade;
          dados.push(informacoesPorStatus);
        });

        return dados;
      },
      valorCabeNaBarra(valor) {
        return valor > 2;
      },
      exibirAlerta(mensagem) {
        this.tipoDeAlerta = "atencao";
        this.mensagemDeAlerta = mensagem;
      },
      criarGrafico(labels, dataset, chartId) {
        const myChart = document.getElementById(chartId).getContext("2d");
        return new Chart(myChart, {
          type: "doughnut",
          data: {
            labels: labels,
            datasets: [dataset],
          },
          options: {
            cutoutPercentage: 60,
            responsive: true,
            legend: {
              position: "right",
              display: false,
              fullWidth: false,
            },
            animation: {
              animateScale: true,
              animateRotate: true,
            },
            tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  const valor =
                    data.datasets[tooltipItem.datasetIndex].data[
                    tooltipItem.index
                    ];
                  const labelDaFaixa = data.labels[tooltipItem.index] + ": ";
                  return labelDaFaixa + valor + "%";
                },
              },
            },
          },
        });
      },
      gerenciarGraficoDeResumo(dadosParaGraficoDeResumo) {
        if (this.graficoDeResumo)
          this.atualizarDadosDoGrafico(
            dadosParaGraficoDeResumo.dataset,
            this.graficoDeResumo
          );
        else
          this.graficoDeResumo = this.criarGrafico(
            dadosParaGraficoDeResumo.labels,
            dadosParaGraficoDeResumo.dataset,
            dadosParaGraficoDeResumo.chartId
          );
      },
      gerenciarGraficoDeRecursosDisponiveis(
        dadosParaGraficoDeRecursosDisponiveis
      ) {
        if (this.graficoDeRecursosDisponiveis)
          this.atualizarDadosDoGrafico(
            dadosParaGraficoDeRecursosDisponiveis.dataset,
            this.graficoDeRecursosDisponiveis
          );
        else
          this.graficoDeRecursosDisponiveis = this.criarGrafico(
            dadosParaGraficoDeRecursosDisponiveis.labels,
            dadosParaGraficoDeRecursosDisponiveis.dataset,
            dadosParaGraficoDeRecursosDisponiveis.chartId
          );
      },
      atualizarDadosDoGrafico(dataset, grafico) {
        grafico.data.datasets.pop();
        grafico.data.datasets.push(dataset);
        grafico.update();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// DashboardParaMcmvCidades.vue?c8c77494